import linksTemplates from './linksTemplates';

import {
  FreeStanding,
  Widgets,
  WithinText,
  Heading,
  Action
} from './linksLayouts';

const linksSet = [
  {
    component: FreeStanding,
    codeTemplate: linksTemplates.freestanding,
    optionsGroup: [
      {
        label: 'Freestanding',
        options: [
          {label: 'Only text', type: 'radio', options:{size: 'xl', iconDirection: null}},
          {label: 'Icon Left', type: 'radio', options:{iconDirection: 'left'}},
          {label: 'Icon Right', type: 'radio', options:{iconDirection: 'right'}},
        ]
      },
      {
        label: 'Background:',
        options: [
          {label: 'Light', type: 'radio', options: {bgColor: null, dark: false}},
          {label: 'Dark', type: 'radio', options: {bgColor: 'black', dark: true}}
        ]
      },
      {
        label: 'Size:',
        options: [
          {label: 'sizes', type: 'dropdown', selectList: [
            {label: '20px', value: 'xl', options: {size: 'xl'}},
            {label: '16px', value: 'l', options: {size: 'l' }},
            {label: '14px', value: 'm', options: {size: 'm' }},
            {label: '12px', value: 's', options: {size: 's' }},
            {label: '11px', value: 'xs', options: {size: 'xs'}},
          ],
          }
        ]
      },
    ]
  },
  {
    name: 'widgets',
    component: Widgets,
    codeTemplate: linksTemplates.widget,
    optionsGroup: [
      {
        label: 'Widgets',
        options: [
          {label: 'Default', type: 'radio', options: {size: 'xl', iconDirection: 'right'}}
        ]
      },
      {
        label: 'Size:',
        options: [
          {label: 'sizes', type: 'dropdown', selectList: [
            {label: '20px', value: 'xl', options: {size: 'xl'}},
            {label: '16px', value: 'l', options: {size: 'l'}},
            {label: '14px', value: 'm', options: {size: 'm'}},
            {label: '12px', value: 's', options: {size: 's'}},
            {label: '11px', value: 'xs', options: {size: 'xs'}},
          ],
          }
        ]
      }
    ]
  },
  {
    name: 'withintext',
    component: WithinText,
    codeTemplate: linksTemplates.withintext,
    optionsGroup: [
      [
        {
          label: 'Within Text',
          options: [
            {label: 'Light', type: 'radio', options: { bgColor: null, medium: false, dark: false, secondaryLight: false, secondaryDark: false}},
            {label: 'Medium', type: 'radio', options: {bgColor: 'light-grey', medium: true, secondaryLight: false, secondaryDark: false}},
            {label: 'Dark', type: 'radio', options: {bgColor: 'black', dark: true, secondaryLight: false, secondaryDark: false}}
          ]
        },
        {
          label: 'Secondary:',
          options: [
            {label: 'Light', type: 'radio', options: {bgColor: 'null', secondaryLight: true, secondaryDark: false}},
            {label: 'Dark', type: 'radio', options: {bgColor: 'black', secondaryDark: true, secondaryLight: false}}
          ]
        },
      ],
      {
        label: 'Size:',
        options: [
          {label: 'sizes', type: 'dropdown', selectList: [
            {label: '20px', value: 'xl', options: {size: 'xl'}},
            {label: '16px', value: 'l', options: {size: 'l'}},
            {label: '14px', value: 'm', options: {size: 'm'}},
            {label: '12px', value: 's', options: {size: 's'}},
            {label: '11px', value: 'xs', options: {size: 'xs'}},
          ],
          }
        ]
      }
    ]
  },
  {
    name: 'heading',
    component: Heading,
    codeTemplate: linksTemplates.heading,
    optionsGroup: [
      {
        label: 'Headings',
        options: [
          {label: 'Default', type: 'radio', options: {}}
        ]
      },
      {
        label: 'Size:',
        options: [
          {label: 'sizes', type: 'dropdown', selectList: [
            {label: '60px', value: 'xl', options: {size: 'xl'}},
            {label: '48px', value: 'l', options: {size: 'l'}},
            {label: '36px', value: 'm', options: {size: 'm'}},
            {label: '30px', value: 's', options: {size: 's'}},
            {label: '24px', value: 'xs', options: {size: 'xs'}}
          ],
          }
        ]
      }
    ]
  },
  {
    name: 'action',
    component: Action,
    codeTemplate: linksTemplates.action,
    optionsGroup: [
      {
        label: 'Action',
        options: [
          {label: 'Large', type: 'radio', options: {size: 'l' }},
          {label: 'Medium', type: 'radio', options: {size: 'm' }},
          {label: 'Small', type: 'radio', options: {size: 's' }}
        ]
      },
      {
        label: 'Background:',
        options: [
          {label: 'Light', type: 'radio', options: {dark: false, bgColor: null}},
          {label: 'Dark', type: 'radio', options: {dark: true, bgColor: 'black'}}
        ]
      }
    ]
  },
];

export default linksSet;



// WEBPACK FOOTER //
// ./src/containers/elements/Links/constants/linksSet.js